import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { PATHS } from 'util/appConstants';
import { fetchUserInfo, selectUser } from 'redux/slices/userSlice';
import { selectAuthenticated } from 'redux/slices/authSlice';
import { setGrowthBookUserAttributes } from 'integrations/growthbook';
import AppRouter from './routes/AppRouter';
import Snackbar from 'components/Snackbar';


const App = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  const authenticated = useSelector(selectAuthenticated);
  const user = useSelector(selectUser);

  useEffect(() => {
    dispatch(fetchUserInfo(history));
  }, [dispatch, history]);

  useEffect(() => {
    if (!authenticated) {
      history.push(PATHS.login);
    }
  }, [authenticated, history]);

  useEffect(() => {
    setGrowthBookUserAttributes(user);
  }, [user]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      {/*location.pathname !== "/login" &&
        <>
          <Navbar checkTourPaths={checkTourPath} checkPaths={checkPath} />
          {checkPath().includes(location.pathname) && <Masterbar {...MASTER_DATA_BAR} />}
          {checkTourPath().includes(location.pathname) && <Masterbar {...TOUR_DATA_BAR} />}
        </>*/
      }
      <AppRouter />
      <Snackbar />
    </>
  );
};

export default App;
